import {TradableProducts} from '../Atoms';
import {EQUITY, FUND, ETF, CEF} from 'src/Api';
import Image from 'next/image';
import favicon from "src/Resources/Images/favicon.ico";

export default function InstrumentInfoBoxes({instrument, instrumentInfo, favorites, profile, documents }) {


    const renderTradableProducts = () => {
        if (instrument && instrument.tradable.tradable) {
            return <div className="ajb-col-12 ajb-col-8-breakpoint margin-bottom-20 padding-top-20 padding-right-10 padding-bottom-20 padding-left-10 darkblue-0-bg border-radius-10 align-items block-sm text-align-center center-align">
                <TradableProducts instrument={instrument} />
            </div>
        }
        return null;
    }

    const renderDocumentsBox = () => {
        const KIIDDocument = (instrument.kiidDocumentSource === 2 || instrument.kiidDocumentSource === 3) ? "Key Information Document (KID)" : "Key Investor Information Document (KIID)";
        
        return <>
            {showDocumentsBox ? <div className="ajb-col-12 ajb-col-8-breakpoint margin-bottom-20 padding-top-20 padding-right-10 padding-bottom-20 padding-left-10 darkblue-0-bg border-radius-10 align-items block-sm text-align-center center-align">
                <p className="block margin-bottom-10 max-characters-none block h7">Before investing please read:</p>
                {showKiidLink &&
                    <p className="max-characters-none margin-bottom-10">
                        <a target="_blank" href={instrument.kiidDocument} className="c-btn waves-effect waves-light button-outline button button--outline-darkblue c-btn-small no-arrow" rel="noreferrer" data-testid="keyInfoDocLink">
                            <i className="far fa-file-alt"></i> {KIIDDocument}
                        </a>
                    </p> }
                {sdrEligible && 
                    <p className="margin-0 max-characters-none">
                        {sdrDocument && sdrDocument.url &&
                        <a href={sdrDocument.url} target="_blank" className="c-btn waves-effect waves-light button-outline button button--outline-darkblue c-btn-small no-arrow" rel="noreferrer">
                            <i className="far fa-file-alt"></i> Sustainability factsheet
                        </a> }
                    </p>}
            </div> : null}
        </>
    }

    const {type} = instrumentInfo;
    const sdrDocument = Array.isArray(documents) && documents.find(doc => parseInt(doc.typeId) === 705);
    const sdrEligible = profile && profile.domicile === 'GBR';
    const showKiidLink = instrument && instrument.kiidRequired && instrument.kiidDocument;
    const showDocumentsBox = instrument && sdrEligible || instrument && showKiidLink;

    switch (type) {
        case CEF:
            return <div className="ajb-grid-row margin-bottom-10 display-flex block-sm">
                {renderTradableProducts()}
                {favorites && favorites.length ? (
                    <div className="ajb-col-12 ajb-col-8-breakpoint margin-bottom-20 padding-top-20 padding-right-10 padding-bottom-20 padding-left-10 darkblue-0-bg border-radius-10 align-items block-sm text-align-center center-align">
                        <p className="block margin-0 max-characters-none inline-block h7" data-testid="includedListText">This is included in our:</p>
                        <p className="margin-0 h7">
                            <a className="darkblue-500-text text-transform-none inline-block text-underline-none font-weight-bold" href={`/markets/investment-trusts`} data-testid="selectedList"><i className="fas fa-balance-scale padding-right-5"></i>Select list of investment trusts</a>
                        </p>
                    </div>
                ) : null}
                {renderDocumentsBox()}
            </div>
        case EQUITY:
            return renderTradableProducts();
        case FUND:
        case ETF:
            return <div className="ajb-grid-row margin-bottom-10 display-flex block-sm">
                {renderTradableProducts()}
                {favorites && favorites.length ? (
                    <div className="ajb-col-12 ajb-col-8-breakpoint margin-bottom-20 padding-top-20 padding-right-10 padding-bottom-20 padding-left-10 darkblue-0-bg border-radius-10 align-items block-sm text-align-center center-align">
                        <p className="block margin-0 max-characters-none inline-block h7" data-testid="includedListText">This is included in our:</p>
                        <p className="margin-0 h7">
                            <a className="darkblue-500-text text-transform-none inline-block text-underline-none font-weight-bold" href={`/investment-ideas/favourite`} data-testid="favouriteFundsList">
                                <Image
                                    alt="" 
                                    src={favicon}
                                    width={20} 
                                    height={15}
                                    className="padding-right-5 inline-block" />Favourite funds list
                            </a>
                        </p>
                    </div>
                ) : null}
                {renderDocumentsBox()}
            </div>
    }

    return null;
}
